import React from "react";
import gsap from "gsap";
import { Splide, SplideSlide } from "@splidejs/react-splide";
import "@splidejs/react-splide/css";
import close from "../images/closeBlanco.svg";
import prev from "../images/prev.png";
import next from "../images/next.png";

const SPLIDE_OPTS = {
  rewind: true,
  gap: '1rem',
  autoplay: false,
  interval: 3000,
  pauseOnHover: false,
  type: 'fade',
  speed: 800,
};

class WorkModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = { currentIndex: 0 };
    this.containerRef = React.createRef();
    this.isOpen = false;
  }

  pauseVideos = () => {
    if (this.containerRef.current) {
      this.containerRef.current.querySelectorAll('video').forEach(v => v.pause());
    }
  }

  open = (index) => {
    this.isOpen = true;
    this.setState({ currentIndex: index }, () => {
      document.body.style.overflow = 'hidden';
      this.containerRef.current.scrollTop = 0;
      gsap.set(this.overlayRef, { display: 'block' });
      gsap.set(this.containerRef.current, { x: '100%' });
      gsap.set(this.contentRef, { opacity: 0 });
      gsap.to(this.overlayRef, { opacity: 1, duration: 0.4 });
      gsap.to(this.containerRef.current, {
        x: '0%', duration: 0.5, ease: 'power3.out',
        onComplete: () => {
          gsap.to(this.contentRef, { opacity: 1, duration: 0.25, ease: 'power2.out' });
        }
      });
    });
  }

  close = () => {
    this.pauseVideos();
    document.body.style.overflow = '';
    this.isOpen = false;

    gsap.to(this.contentRef, {
      opacity: 0, y: 16, duration: 0.2, ease: 'power2.in',
      onComplete: () => {
        gsap.to(this.containerRef.current, {
          x: '100%', duration: 0.4, ease: 'power3.in',
          onComplete: () => {
            gsap.set(this.overlayRef, { display: 'none' });
            gsap.set(this.contentRef, { opacity: 1, y: 0 });
          }
        });
        gsap.to(this.overlayRef, { opacity: 0, duration: 0.3 });
      }
    });
  }

  navigate = (dir) => {
    const items = this.props.items;
    if (!items) return;
    this.pauseVideos();

    const nextIndex = (this.state.currentIndex + dir + items.length) % items.length;

    gsap.to(this.contentRef, {
      opacity: 0, x: dir * -30, duration: 0.2, ease: 'power2.in',
      onComplete: () => {
        this.setState({ currentIndex: nextIndex }, () => {
          this.containerRef.current.scrollTop = 0;
          gsap.fromTo(this.contentRef,
            { opacity: 0, x: dir * 30 },
            { opacity: 1, x: 0, duration: 0.3, ease: 'power2.out' }
          );
        });
      }
    });
  }

  renderSection = (section, i) => {
    const hasCarousel = section.images && section.images.length > 1;

    return (
      <div key={i} className="work-modal-section">
        {section.title && <h2 className="work-modal-title">{section.title}</h2>}
        {section.description && (
          <p className="work-modal-description">
            {section.description.split('\n\n').map((par, i) => (
              <span key={i}>{par}{i < section.description.split('\n\n').length - 1 && <><br/><br/></>}</span>
            ))}
          </p>
        )}
        {section.url && <a className="work-modal-url" href={section.url} target="_blank" rel="noopener noreferrer">{section.url}</a>}

        {section.video && (
          <div className={`work-modal-video${section.portrait ? ' work-modal-video--portrait' : ''}`}>
            <video key={section.video} controls playsInline preload="none" poster={section.poster || undefined}>
              <source src={section.video} type="video/mp4" />
            </video>
          </div>
        )}

        {section.images && section.images.length === 1 && (
          <div className={`work-modal-single-image${section.portrait ? ' work-modal-single-image--portrait' : ''}`}>
            <img src={section.images[0]} alt="proyecto" />
          </div>
        )}

        {hasCarousel && (
          <div className={`work-modal-carousel${section.portrait ? ' work-modal-carousel--portrait' : ''}`}>
            <Splide options={SPLIDE_OPTS}>
              {section.images.map((img, j) => (
                <SplideSlide key={j}>
                  <img src={img} alt={`slide ${j + 1}`} width="100%" />
                </SplideSlide>
              ))}
            </Splide>
          </div>
        )}
      </div>
    );
  }

  render() {
    const { currentIndex } = this.state;
    const items = this.props.items || [];
    const total = items.length;
    const item = items[currentIndex] || {};
    const sections = item.sections || [];

    return (
      <>
        <div
          className="work-modal-overlay"
          ref={el => this.overlayRef = el}
          onClick={this.close}
          style={{ display: 'none', opacity: 0 }}
        />
        <div className="work-modal" ref={this.containerRef} style={{ transform: 'translateX(100%)' }}>

          <div className="work-modal-header">
            {total > 1 && (
              <div className="work-modal-nav">
                <button className="work-modal-nav-btn" onClick={() => this.navigate(-1)}>
                  <img width={24} src={prev} alt="anterior" />
                </button>
                <span className="work-modal-counter">{currentIndex + 1} / {total}</span>
                <button className="work-modal-nav-btn" onClick={() => this.navigate(1)}>
                  <img width={24} src={next} alt="siguiente" />
                </button>
              </div>
            )}
            <button className="work-modal-close" onClick={this.close}>
              <img width={28} src={close} alt="cerrar" />
            </button>
          </div>

          <div className="work-modal-content" ref={el => this.contentRef = el}>
            {sections.map((section, i) => this.renderSection(section, i))}
          </div>
        </div>
      </>
    );
  }
}

export default WorkModal;
